import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import "../styles/Formularios.css";
import Hardware from "./Hardware";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";

function RegistrarUsuarios() {

    const { setSubModuloActual, logout } = useGlobal();
    const [idUsuario, setIdUsuario] = useState("");
    const [usuario, setUsuario] = useState("");
    const [aPaterno, setApaterno] = useState("");
    const [aMaterno, setAmaterno] = useState("");
    const [correo, setCorreo] = useState("");
    const [idCargo, setIdCargo] = useState("");
    const [idDireccion, setIdDireccion] = useState("");
    const [idSede, setIdSede] = useState("");
    const [idEdificio, setIdEdificio] = useState("");
    const [idNivel, setIdNivel] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [mostrarHardware, setMostrarHardware] = useState(false);
    const apiFetch = useApiFetch();

    // Función para resetear todos los campos
    const resetForm = () => {
        setIdUsuario("");
        setUsuario("");
        setApaterno("");
        setAmaterno("");
        setCorreo("");
        setIdCargo("");
        setIdDireccion("");
        setIdSede("");
        setIdEdificio("");
        setIdNivel("");
    };

    const handleRegistrar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        // Validar campos obligatorios, no vacios o solo espacios
        if (
            !idUsuario.trim() ||
            !usuario.trim() ||
            !aPaterno.trim() ||
            !aMaterno.trim() ||
            !correo.trim() ||
            !idCargo ||
            !idDireccion ||
            !idSede ||
            !idEdificio ||
            !idNivel
        ) {
            setError("Todos los campos son obligatorios.");
            return;
        }

        // Validar idUsuario: exactamente 7 dígitos
        if (!/^\d{7}$/.test(idUsuario)) {
            setError("El ID de usuario debe contener exactamente 7 dígitos numéricos.");
            return;
        }

        // Validar usuario, aPaterno y aMaterno: solo letras y máximo 50 caracteres
        const nombreRegex = /^[A-Za-zÁÉÍÓÚÑ\s]{1,50}$/;
        if (!nombreRegex.test(usuario)) {
            setError("El nombre solo puede contener letras y máximo 50 caracteres.");
            return;
        }
        if (!nombreRegex.test(aPaterno)) {
            setError("El apellido paterno solo puede contener letras y máximo 50 caracteres.");
            return;
        }
        if (!nombreRegex.test(aMaterno)) {
            setError("El apellido materno solo puede contener letras y máximo 50 caracteres.");
            return;
        }

        // Validar correo: formato correcto y máximo 50 caracteres
        const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!correoRegex.test(correo) || correo.length > 50) {
            setError("El correo debe tener formato válido y no exceder 50 caracteres.");
            return;
        }

        setLoading(true);

        try {

            const data = await apiFetch("registrar_usuarios.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_usuario: idUsuario,
                    usuario,
                    a_paterno: aPaterno,
                    a_materno: aMaterno,
                    correo,
                    id_cargo: idCargo,
                    id_direccion: idDireccion,
                    id_sede: idSede,
                    id_edificio: idEdificio,
                    id_nivel: idNivel
                })
            }, logout);

            if (data.status === "ok") {
                resetForm();
                setSuccess(data.message);
                setTimeout(() => {
                    setSubModuloActual(null);
                    setMostrarHardware(true);
                }, 3000);
            } else {
                setError(data.message || "Error al registrar usuario.");
                setTimeout(() => {
                    setSubModuloActual(null);
                    setMostrarHardware(true);
                }, 4000);
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Este useEffect siempre se ejecuta, pero solo programa el timer si hay error o success
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 2000); // 2 segundos

            // limpiar el timer si cambia el estado o se desmonta
            return () => clearTimeout(timer);
        }
    }, [error, success]);

    if (mostrarHardware) {
        return <Hardware />;
    }

    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}

            <form onSubmit={handleRegistrar}>

                <InputGenerico
                    value={idUsuario}
                    setValue={setIdUsuario}
                    label="Número de empleado"
                    maxLength={7}
                    allowedChars="0-9"
                    placeholder="7120000"
                    title="Debe contener exactamente 7 dígitos numéricos"
                />

                <InputGenerico
                    value={usuario}
                    setValue={setUsuario}
                    label="Nombre(s) del empleado"
                    maxLength={50}
                    allowedChars="A-Z ÁÉÍÓÚÑ"
                    transform="uppercase"
                    placeholder="Ingrese el nombre"
                    title="Máximo 50 caracteres"
                />

                <InputGenerico
                    value={aPaterno}
                    setValue={setApaterno}
                    label="Apellido paterno"
                    maxLength={50}
                    allowedChars="A-Z ÁÉÍÓÚÑ"
                    transform="uppercase"
                    placeholder="Ingrese el apellido paterno"
                    title="Máximo 50 caracteres"
                />

                <InputGenerico
                    value={aMaterno}
                    setValue={setAmaterno}
                    label="Apellido materno"
                    maxLength={50}
                    allowedChars="A-Z ÁÉÍÓÚÑ"
                    transform="uppercase"
                    placeholder="Ingrese el apellido materno"
                    title="Máximo 50 caracteres"
                />

                <InputGenerico
                    type="email"
                    value={correo}
                    setValue={setCorreo}
                    label="Correo electrónico"
                    maxLength={50}
                    allowedChars="A-Za-z0-9@._-"
                    transform="lowercase"
                    placeholder="ejemplo@dominio.com"
                    title="Máximo 50 caracteres"
                />

                <InputSelectGenerico
                    idSeleccionado={idCargo}
                    setIdSeleccionado={setIdCargo}
                    label="Cargo"
                    apiUrl={`consultar_cargos.php`}
                    valueField="id_cargo"
                    displayField="cargo"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un cargo"
                />

                <InputSelectGenerico
                    idSeleccionado={idDireccion}
                    setIdSeleccionado={setIdDireccion}
                    label="Dirección Administrativa"
                    apiUrl={`consultar_direcciones.php`}
                    valueField="id_direccion"
                    displayField="direccion_a"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione Dirección Administrativa"
                />

                <InputSelectGenerico
                    idSeleccionado={idSede}
                    setIdSeleccionado={setIdSede}
                    label="Sede"
                    apiUrl={`consultar_sedes.php`}
                    valueField="id_sede"
                    displayField="acronimo"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione una sede"
                />

                <InputSelectGenerico
                    idSeleccionado={idEdificio}
                    setIdSeleccionado={setIdEdificio}
                    label="Edificio"
                    apiUrl={`consultar_edificios.php`}
                    valueField="id_edificio"
                    displayField="edificio"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un edificio"
                />

                <InputSelectGenerico
                    idSeleccionado={idNivel}
                    setIdSeleccionado={setIdNivel}
                    label="Nivel"
                    apiUrl={`consultar_niveles.php`}
                    valueField="id_nivel"
                    displayField="nivel"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un piso o nivel"
                />

                <div className="form-buttons">
                    <button type="submit" disabled={loading}>
                        {loading ? "Registrando..." : "Registrar"}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default RegistrarUsuarios;